import React from 'react';
import { APP_NAME } from '../constants/global';

export const MappingTitle: React.FC = () => {
  return <h1 className="absolute top-0 left-0 p-4 font-light text-2xl ">{APP_NAME}</h1>;
};
